/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';

export interface ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Params {
  reportId?: string;
}

export function apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ConstructionDayReport>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain.PATH, 'get');
  if (params) {
    rb.query('reportId', params.reportId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ConstructionDayReport>;
    })
  );
}

apiV0ConstructiondayreportGetConstructionDayReportsByIdGet$Plain.PATH = '/api/v0/constructiondayreport/getConstructionDayReportsById';
